export default {"src":"/_next/static/media/NoMoreVacancies.eb4aefb2.svg","height":151,"width":159};